import { Heading } from "@chakra-ui/react";
import TaskNotificationChannelSettings from "features/Settings/TaskNotificationChannel";
import TaskResolutionSettings from "features/Settings/TaskResolution";
import { useNavbar } from "hooks/useNavbar";
import AppPage from "layouts/AppPage";
import InnerSidebar from "layouts/InnerSidebar";
import { useEffect } from "react";

export default function TaskSettingsPage() {
  const { setBackLocationPath, setBackLocationName, setPageTitle } = useNavbar();

  useEffect(() => {
    setPageTitle("Task Settings");
    return () => {
      setBackLocationPath(null);
      setBackLocationName(null);
      setPageTitle(null);
    };
  }, [setBackLocationPath, setBackLocationName, setPageTitle]);

  return (
    <AppPage>
      <InnerSidebar>
        <Heading mb="8" size="sm" color="fg.subtle">
          Task Settings
        </Heading>
        <TaskResolutionSettings />
        <TaskNotificationChannelSettings />
      </InnerSidebar>
    </AppPage>
  );
}
